export const BLOCK_TYPES = {
  TEXT: 'text',
  IMAGE: 'image',
  HEADING: 'heading',
  BUTTON: 'button',
  COLUMNS: 'columns',
  MENU: 'menu',
  DIVIDER: 'divider',
  SPACER: 'spacer',
  HTML: 'html',
  SOCIAL: 'social',
  VIDEO: 'video',
  TABLE: 'table'
}

export const DEFAULT_SETTINGS = {
  [BLOCK_TYPES.TEXT]: {
    content: '<p>Start typing your text here...</p>',
    fontSize: '16px',
    fontFamily: 'Arial, sans-serif',
    fontWeight: 'normal',
    color: '#333333',
    textAlign: 'left',
    lineHeight: '1.6',
    padding: { top: '2%', right: '4%', bottom: '2%', left: '4%' },
    margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
    backgroundColor: 'transparent',
    borderWidth: '0px',
    borderColor: '#cccccc',
    borderRadius: '0px'
  },

  [BLOCK_TYPES.HEADING]: {
    content: 'Heading Text',
    fontSize: '32px',
    fontFamily: 'Arial, sans-serif',
    fontWeight: 'bold',
    color: '#000000',
    textAlign: 'center',
    lineHeight: '1.2',
    padding: { top: '4%', right: '4%', bottom: '4%', left: '4%' },
    margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
    backgroundColor: 'transparent',
    borderWidth: '0px',
    borderColor: '#cccccc',
    borderRadius: '0px'
  },

  [BLOCK_TYPES.IMAGE]: {
    src: '',
    alt: 'Image',
    width: '100%',
    height: 'auto',
    link: '',
    textAlign: 'center',
    padding: { top: '2%', right: '0%', bottom: '2%', left: '0%' },
    margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
    backgroundColor: 'transparent',
    borderWidth: '0px',
    borderColor: '#cccccc',
    borderRadius: '0px'
  },

  [BLOCK_TYPES.BUTTON]: {
    text: 'Click Here',
    link: '#',
    fontSize: '16px',
    fontFamily: 'Arial, sans-serif',
    fontWeight: 'bold',
    color: '#ffffff',
    backgroundColor: '#007bff',
    textAlign: 'center',
    padding: { top: '12px', right: '24px', bottom: '12px', left: '24px' },
    margin: { top: '2%', right: '0%', bottom: '2%', left: '0%' },
    borderWidth: '0px',
    borderColor: '#0056b3',
    borderRadius: '6px',
    width: 'auto'
  },

  [BLOCK_TYPES.COLUMNS]: {
    columnCount: 2,
    gap: '2%',
    padding: { top: '2%', right: '0%', bottom: '2%', left: '0%' },
    margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
    backgroundColor: 'transparent',
    columns: [
      { id: 'col-0', blocks: [], content: '' },
      { id: 'col-1', blocks: [], content: '' }
    ]
  },

  [BLOCK_TYPES.MENU]: {
    links: [
      { text: 'Home', url: '#' },
      { text: 'About', url: '#' },
      { text: 'Contact', url: '#' }
    ],
    orientation: 'horizontal',
    separator: ' | ',
    fontSize: '14px',
    fontFamily: 'Arial, sans-serif',
    color: '#007bff',
    textAlign: 'center',
    padding: { top: '3%', right: '4%', bottom: '3%', left: '4%' },
    margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
    backgroundColor: 'transparent'
  },

  [BLOCK_TYPES.DIVIDER]: {
    width: '100%',
    height: '1px',
    color: '#cccccc',
    style: 'solid',
    padding: { top: '2%', right: '0%', bottom: '2%', left: '0%' },
    margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }
  },

  [BLOCK_TYPES.SPACER]: {
    height: '20px',
    backgroundColor: 'transparent'
  },

  [BLOCK_TYPES.HTML]: {
    htmlContent: '<!-- Enter your HTML code here -->\n<div style="padding: 20px; text-align: center;">\n  <p>Custom HTML Block</p>\n</div>',
    backgroundColor: 'transparent',
    padding: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
    margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }
  },

  [BLOCK_TYPES.SOCIAL]: {
    networks: [
      { name: 'facebook', url: '', enabled: true },
      { name: 'twitter', url: '', enabled: true },
      { name: 'instagram', url: '', enabled: true },
      { name: 'linkedin', url: '', enabled: false },
      { name: 'youtube', url: '', enabled: false },
      { name: 'tiktok', url: '', enabled: false },
      { name: 'pinterest', url: '', enabled: false },
      { name: 'github', url: '', enabled: false }
    ],
    iconSize: '32',
    iconSpacing: '8',
    iconStyle: 'colored',
    iconRadius: '50%',
    textAlign: 'center',
    padding: { top: '3%', right: '4%', bottom: '3%', left: '4%' },
    margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
    backgroundColor: 'transparent'
  },

  [BLOCK_TYPES.VIDEO]: {
    videoUrl: '',
    thumbnailUrl: '',
    altText: 'Video thumbnail',
    width: '100%',
    textAlign: 'center',
    padding: { top: '2%', right: '0%', bottom: '2%', left: '0%' },
    margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
    backgroundColor: 'transparent',
    borderWidth: '0px',
    borderColor: '#cccccc',
    borderRadius: '0px'
  },

  [BLOCK_TYPES.TABLE]: {
    rows: [
      ['Header 1', 'Header 2', 'Header 3'],
      ['Row 1, Col 1', 'Row 1, Col 2', 'Row 1, Col 3'],
      ['Row 2, Col 1', 'Row 2, Col 2', 'Row 2, Col 3']
    ],
    showHeader: true,
    striped: true,
    tableWidth: '100%',
    headerBackgroundColor: '#f8f9fa',
    headerTextColor: '#333333',
    tableBorderColor: '#dee2e6',
    cellPadding: '10px',
    fontSize: '14px',
    fontFamily: 'Arial, sans-serif',
    color: '#333333',
    padding: { top: '2%', right: '4%', bottom: '2%', left: '4%' },
    margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }
  }
}

export const createBlock = (type, bodySettings) => {
  const defaults = DEFAULT_SETTINGS[type]
  // Deep clone to avoid reference sharing
  const settings = JSON.parse(JSON.stringify(defaults))

  // Inherit global styles from bodySettings if available
  if (bodySettings) {
    if (bodySettings.fontFamily && settings.fontFamily) {
      settings.fontFamily = bodySettings.fontFamily
    }
    if (bodySettings.linkColor && type === 'menu' && settings.color) {
      settings.color = bodySettings.linkColor
    }
  }

  return {
    id: `block-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
    type,
    settings
  }
}
